import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalController } from '@ionic/angular/standalone';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { trashOutline, logOutOutline } from 'ionicons/icons';

export interface ResultModalProps {
  type: 'success' | 'error' | 'confirm';
  title: string;
  message: string;
  buttonText?: string;
  /** For type 'confirm': cancel button label. */
  cancelButtonText?: string;
  /** For type 'confirm': primary action button label (e.g. Logout, Delete). */
  confirmButtonText?: string;
  /** For type 'confirm': when true, primary button uses destructive (red) style. */
  confirmDestructive?: boolean;
  /** For type 'confirm': when true, show logout icon instead of delete (trash) icon. */
  confirmLogout?: boolean;
}

@Component({
  selector: 'app-result-modal',
  standalone: true,
  templateUrl: './result-modal.component.html',
  styleUrls: ['./result-modal.component.scss'],
  imports: [CommonModule, IonButton, IonIcon]
})
export class ResultModalComponent {
  @Input() type: 'success' | 'error' | 'confirm' = 'success';
  @Input() title = 'Success!';
  @Input() message = '';
  @Input() buttonText: string | null = null;
  @Input() cancelButtonText = 'Cancel';
  @Input() confirmButtonText: string | null = null;
  @Input() confirmDestructive = false;
  @Input() confirmLogout = false;

  constructor(private modalController: ModalController) {
    addIcons({ trashOutline, logOutOutline });
  }

  get displayButtonText(): string {
    if (this.buttonText) return this.buttonText;
    return this.type === 'success' ? 'OKAY' : 'TRY AGAIN';
  }

  dismiss(role: 'cancel' | 'confirm' = 'confirm'): void {
    this.modalController.dismiss(null, role);
  }
}
